(() => {
  /*!**********************************************!*\
  !*** ./scripts/components/variant-select.js ***!
  \**********************************************/
  var e = document.querySelectorAll(
      ".product-content-mobile .product-form__chips .product-form__chip"
    ),
    t = JSON.parse(
      document.querySelector(".product-json-list").innerHTML
    ).variants;
  function o(e, o) {
    e.forEach((e) => {
      if ("class" === e.attributeName) {
        if (
          document.querySelectorAll(
            ".desktop .product-form__chips .product-form__chip.selected"
          ).length ===
          document
            .querySelector(".product-content-mobile")
            .querySelectorAll(".product-content-mobile .product-form__chips")
            .length
        ) {
          let e = window.location.search.replace("?variant=", ""),
            o = "disable",
            i = "Add to bag",
            r = document.querySelectorAll(".left-message.message"),
            c = document.querySelectorAll(".right-message.message");
          r.forEach((e) => {
            (e.style.visibility = "hidden"), e.classList.remove("visible");
          }),
            c.forEach((e) => {
              (e.style.visibility = "hidden"), e.classList.remove("visible");
            }),
            t.forEach((t, l) => {
              if (t.id == e)
                return (
                  t.available
                    ? t.next_incoming_date
                      ? (c.forEach((e) => {
                          (e.style.visibility = "visible"),
                            e.classList.add("visible"),
                            (e.innerText =
                              "Expected to ship on " + t.next_incoming_date);
                        }),
                        (i = "Preorder"),
                        (o = ""))
                      : 1 == t.inventory
                      ? (c.forEach((e) => {
                          (e.style.visibility = "visible"),
                            e.classList.add("visible"),
                            (e.innerText = "Only 1 item left");
                        }),
                        (i = "Add to bag"),
                        (o = ""))
                      : ((i = "Add to bag"), (o = ""))
                    : (r.forEach((e) => {
                        (e.style.visibility = "visible"),
                          e.classList.add("visible"),
                          (e.innerText = "Join the waitlist");
                      }),
                      (i = "Notify Me"),
                      (o = "waitlist")),
                  (function (e, t) {
                    document
                      .querySelectorAll(".product-form__cart-submit:not(tryon-button)")
                      .forEach((o, i) => {
                        o.removeAttribute("disabled")
                        "disable" === e
                          ? (o.setAttribute("disabled", e),
                            o.classList.remove("klaviyo-bis-trigger"))
                          : "waitlist" === e
                          ? o.classList.add("klaviyo-bis-trigger")
                          : (o.removeAttribute("disabled"),
                            o.classList.remove("klaviyo-bis-trigger")),
                          (o.querySelector(
                            "span[data-add-to-cart-text]"
                          ).innerHTMLNOPE = t);
                      });
                  })(o, i),
                  !1
                );
            });
        }
      }
    });
  }
  t.forEach((t, o) => {
    1 !== t.options.length ||
      t.available ||
      e.forEach((e, o) => {
        e.getAttribute("aria-label") === t.option1 &&
          e.classList.add("unavailable");
      });
  }),
    e.forEach((e, t) => {
      new MutationObserver(o).observe(e, { attributes: !0 }),
        e.addEventListener("click", function () {
          let e = this.getAttribute("data-button"),
            t = document.querySelector(
              ".product__content.hide-xs .product-form__chips .product-form__chip[data-button=" +
                e +
                "]"
            );
          console.log(t), t.click();
        });
    }),
    document
      .querySelectorAll(".product-content-mobile .product-form__cart-submit:not(tryon-button)")
      .forEach((e, t) => {
        e.addEventListener("click", function () {
          document
            .querySelectorAll(".desktop .product-form__cart-submit:not(tryon-button)")[0]
            .click();
        });
      }),
    document
      .querySelector(".smooth-scroll")
      .addEventListener("click", function (e) {
        e.preventDefault();
        const t = this.getAttribute("href"),
          o = document.querySelector(t).offsetTop - 100;
        scroll({ top: o, behavior: "smooth" });
      }),
    document
      .querySelectorAll(".desktop .product__color-swatch")
      .forEach((e, t) => {
        let o = document.querySelector(".color-name");
        e.addEventListener("mouseover", function () {
          (o.innerHTML = this.getAttribute("data-label")),
            (o.style.display = "block");
        }),
          e.addEventListener("mouseout", function () {
            o.style.display = "none";
          });
      });
})();
